import { useSeo } from "@/lib/seo";

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="font-display text-xl text-white mb-3">{title}</h2>
    <div className="text-gray-400 leading-relaxed space-y-3 text-sm">{children}</div>
  </div>
);

export default function Cookie() {
  useSeo({ title: "Cookie Policy", description: "Informativa sui cookie di Opera Real Estate Partners." });
  return (
    <div className="bg-[#0D1B2A]">
      <section className="max-w-3xl mx-auto px-5 lg:px-8 py-20">
        <div className="border border-[#C5A059]/30 bg-[#1E2229] p-4 mb-10">
          <p className="text-sm text-[#C5A059]">
            ⚠︎ BOZZA — testo standard da far validare da un legale prima della pubblicazione.
          </p>
        </div>
        <h1 className="font-display font-light text-4xl text-white mb-8">Cookie Policy</h1>

        <Section title="1. Cosa sono i cookie">
          <p>
            I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell'utente,
            dove vengono memorizzati per essere ritrasmessi agli stessi siti alla visita successiva.
          </p>
        </Section>
        <Section title="2. Cookie tecnici">
          <p>
            Utilizziamo cookie tecnici necessari al funzionamento del sito e all'area riservata. Non
            richiedono consenso.
          </p>
        </Section>
        <Section title="3. Cookie di misurazione e terze parti">
          <p>
            Previo consenso, potremo utilizzare strumenti di analytics (es. Google Analytics) per
            misurare l'utilizzo del sito. L'integrazione è predisposta e verrà attivata solo dopo la
            configurazione e la raccolta del consenso.
          </p>
        </Section>
        <Section title="4. Gestione delle preferenze">
          <p>
            Puoi gestire o disabilitare i cookie tramite le impostazioni del tuo browser. La
            disabilitazione di alcuni cookie potrebbe limitare le funzionalità del sito.
          </p>
        </Section>
      </section>
    </div>
  );
}
